import React from "react"

import { trEventBe } from "~/libs/analytics"

import { HELP_INNER_HTML, HELP_PAGE_CSS } from "./helpFromHtml"

type HelpBodyProps = {
  topUrl: string
}

export const HelpBody: React.FC<HelpBodyProps> = ({ topUrl }) => {
  const html = HELP_INNER_HTML.replace(
    '<a class="header__arrow" href="/">',
    `<a class="header__arrow" href="${topUrl}">`
  )

  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = (event.target as HTMLElement).closest("a")
    if (!anchor?.href.startsWith("mailto:easygames-support@mail.mediba.jp")) return
    trEventBe(anchor, "よくある質問", "Q&A", "イージーゲーム お問い合わせ", event.nativeEvent)
  }

  return (
    <div
      className="help-root"
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: `<style>${HELP_PAGE_CSS}</style>${html}` }}
    />
  )
}
